import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function TickShieldCircle({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <TickShieldCircle.Outline {...props} />
  ) : (
    <TickShieldCircle.Solid {...props} />
  );
}

TickShieldCircle.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="1.5"
          className="icon-outline"
        />
        <path
          d="M12 18C11.9 18 11.8 17.98 11.71 17.93L9.25 16.65C8.47 16.23 7.88 15.76 7.4 15.2C6.35 14.03 5.77 12.53 5.77 10.98L5.74 6.91C5.74 6.32 6.12 5.79 6.68 5.59L11.74 3.81C12.04 3.7 12.38 3.7 12.69 3.81L17.76 5.54C18.32 5.73 18.71 6.26 18.71 6.85L18.74 10.93C18.75 12.48 18.19 13.98 17.16 15.16C16.69 15.7 16.1 16.17 15.33 16.59L12.9 17.92C12.81 17.98 12.71 18 12.61 18"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <path
          d="M10.5 12L11.5 13L14 10.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

TickShieldCircle.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <circle cx="12" cy="12" r="11" className="icon-secondary" />
        <path
          opacity="0.4"
          d="M12 18C11.9 18 11.8 17.98 11.71 17.93L9.25 16.65C8.47 16.23 7.88 15.76 7.4 15.2C6.35 14.03 5.77 12.53 5.77 10.98L5.74 6.91C5.74 6.32 6.12 5.79 6.68 5.59L11.74 3.81C12.04 3.7 12.38 3.7 12.69 3.81L17.76 5.54C18.32 5.73 18.71 6.26 18.71 6.85L18.74 10.93C18.75 12.48 18.19 13.98 17.16 15.16C16.69 15.7 16.1 16.17 15.33 16.59L12.9 17.92C12.81 17.98 12.71 18 12.61 18"
          className="icon-primary"
        />
        <path
          d="M11.5 14C11.35 14 11.2 13.94 11.09 13.84L9.65 12.46C9.43 12.24 9.43 11.88 9.65 11.66C9.87 11.44 10.24 11.44 10.46 11.66L11.49 12.65L13.96 10.22C14.18 10 14.55 10 14.77 10.22C14.99 10.44 14.99 10.8 14.77 11.02L11.9 13.83C11.8 13.94 11.65 14 11.5 14Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
